export default __webpack_public_path__ + "static/media/LAS0910.34I-41210_-24587_0.ce7da812.jpg";